import { Column } from 'react-table';

import { Button, Card, Drawer, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { LoadingButton } from '@mui/lab';

import IndexTable from 'src/components/Commons/Table/index-table';
import { isPermissionFuntion } from 'src/utils/commons/permission';
import { FunctionEnum, PageRouteEnum } from 'src/utils/enums/permissionType';
import useProductTable from 'src/hooks/Products/useProductTable';
import CreateProduct from '../Create';
import { ProductStatus, TProductItem } from 'src/types/Products/product.model';
import { useCallback } from 'react';
import toastHelper from 'src/components/Forms/Toastify';

type ProductTableProps = {
  searchText: string;
};

function ProductTable({ searchText }: ProductTableProps) {
  const {
    profile,
    location,
    history,

    response,
    isFetching,
    setId,
    columns,
    filters,
    setFilters,
    onSubmit,
    register,
    handleSubmit,
    handleFetchData,
    handleReset,
    headerRef,
    isDrawerOpen,
    setIsDrawerOpen
  } = useProductTable();

  const handleCreatedSuccess = useCallback((id: number, success: boolean) => {
    if (success) {
      toastHelper.showSuccess('Cập nhật sản phẩm thành công');
      setId(0), setIsDrawerOpen(false);
    } else toastHelper.showSuccess('Cập nhật sản phẩm thất bại');
  }, []);
  return (
    <div className="w-full">
      <Card className="w-full p-8 mb-4" sx={{ p: 4 }}>
        <Grid spacing={0} container className="flex" columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={4}>
            <TextField
              {...register('keyword')}
              fullWidth
              placeholder="Từ khóa bất kỳ"
              id="keyWord"
              label="Từ khóa"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel id="roleId">Trạng thái</InputLabel>
              <Select labelId="roleId" id="roleId" label="Trạng thái" {...register(`status`)}>
                <MenuItem value="">
                  <em>Chọn trạng thái</em>
                </MenuItem>
                <MenuItem key={ProductStatus.Active} value={ProductStatus.Active}>
                  Kích hoạt
                </MenuItem>
                <MenuItem key={ProductStatus.UnActive} value={ProductStatus.UnActive}>
                  Khóa
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
              <LoadingButton
                loading={isFetching}
                variant="contained"
                color="info"
                endIcon={<SearchIcon />}
                onClick={handleSubmit(onSubmit)}
              >
                Tìm kiếm
              </LoadingButton>
              <Button variant="outlined" color="secondary" onClick={handleReset}>
                Reset
              </Button>
              {isPermissionFuntion(PageRouteEnum.LIST_PRODUCT, FunctionEnum.CREATE, profile) && (
                <Button variant="contained" onClick={() => setIsDrawerOpen(true)}>
                  Thêm mới sản phẩm
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Card>
      <Card>
        <IndexTable
          columns={columns as Column<TProductItem>[]}
          data={response?.data?.items || []}
          loading={isFetching}
          pageCount={response?.data?.pageNumber ?? 0}
          totalDataCount={response?.data?.totalCount ?? 0}
          searchText={searchText}
          location={location}
          history={history}
          filters={filters}
          setFilters={setFilters}
          onFetchData={handleFetchData}
          headerRef={headerRef}
        />
      </Card>

      <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
        <CreateProduct handleCreatedSuccess={handleCreatedSuccess} />
      </Drawer>
    </div>
  );
}

export default ProductTable;
